import { computed, inject, NgModule } from '@angular/core';
import {
    BOTTOM_MENU_ITEM_IDS,
    BottomMenuService,
} from '@interacta/feature-bottom-menu';
import { AttachmentInputService } from '@modules/shared-v2/services/attachment-input.service';
import { Store } from '@ngrx/store';
import { UploadDialogComponent } from './components/upload-dialog/upload-dialog.component';
import { getUploadFeature } from './store/upload.selector';

export const UPLOAD_ATTACHMENT_INPUT_SERVICE =
    'UPLOAD_ATTACHMENT_INPUT_SERVICE';

@NgModule({
    providers: [
        {
            provide: UPLOAD_ATTACHMENT_INPUT_SERVICE,
            useClass: AttachmentInputService,
        },
    ],
})
export class UploadDialogModule {
    private readonly store = inject(Store);

    private readonly isDialogOpen = computed(
        () => this.store.selectSignal(getUploadFeature)().isDialogOpen,
    );
    constructor(private bottomMenuService: BottomMenuService) {
        this.bottomMenuService.addComponent(
            {
                id: BOTTOM_MENU_ITEM_IDS.UPLOAD_DIALOG,
                type: UploadDialogComponent,
                isOpen: this.isDialogOpen,
            },
            true,
        );
    }
}
